"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HatColorName;
(function (HatColorName) {
    HatColorName["Black"] = "Black";
    HatColorName["Blue01"] = "Blue01";
    HatColorName["Blue02"] = "Blue02";
    HatColorName["Blue03"] = "Blue03";
    HatColorName["Gray01"] = "Gray01";
    HatColorName["Gray02"] = "Gray02";
    HatColorName["Heather"] = "Heather";
    HatColorName["PastelBlue"] = "PastelBlue";
    HatColorName["PastelGreen"] = "PastelGreen";
    HatColorName["PastelOrange"] = "PastelOrange";
    HatColorName["PastelRed"] = "PastelRed";
    HatColorName["PastelYellow"] = "PastelYellow";
    HatColorName["Pink"] = "Pink";
    HatColorName["Red"] = "Red";
    HatColorName["White"] = "White";
})(HatColorName || (HatColorName = {}));
exports.default = HatColorName;
